var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAudit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    style: {
      enableBackground: "new 0 0 256 256"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;}\r\n\t.st2{fill:none;stroke:#6B1D1D;stroke-width:0.5;stroke-miterlimit:10;}\r\n\t.st3{fill:#3A312A;}\r\n\t.st4{fill:#87796F;}\r\n\t.st5{fill:#D5DE58;}\r\n\t.st6{fill:#695B51;}\r\n\t.st7{fill:#FCE8CB;}\r\n\t.st8{fill:#F16C7A;}\r\n\t.st9{fill:#8AC6DD;}\r\n\t.st10{fill:#DECAAD;}\r\n\t.st11{fill:#D6DF58;}\r\n\t.st12{fill-rule:evenodd;clip-rule:evenodd;fill:#FCE8CB;}\r\n\t.st13{fill:#F5978A;}\r\n\t.st14{fill:#D7E057;}\r\n\t.st15{fill-rule:evenodd;clip-rule:evenodd;fill:#87796F;}\r\n\t.st16{fill:#6CA8BF;}\r\n\t.st17{fill:#B9C239;}\r\n\t.st18{fill:#D34E5C;}\r\n\t.st19{fill:#FAE6CA;}\r\n\t.st20{fill:#F8E4C8;}\r\n\t.st21{fill:#8AC5DC;}\r\n\t.st22{fill:#EF6D7A;}\r\n\t.st23{fill:#EB6E7A;}\r\n\t.st24{fill:#89C4DB;}\r\n\t.st25{fill-rule:evenodd;clip-rule:evenodd;fill:#F16C7A;}\r\n\t.st26{fill:#F7E3C7;}\r\n\t.st27{fill:#F6E2C6;}\r\n\t.st28{fill:#ED6E7A;}\r\n\t.st29{fill:#8AC3DA;}\r\n\t.st30{fill:#D5DC57;}\r\n\t.st31{fill-rule:evenodd;clip-rule:evenodd;fill:#D7E057;}\r\n\t.st32{fill-rule:evenodd;clip-rule:evenodd;fill:#F8E4C8;}\r\n\t.st33{fill:#D4DB56;}\r\n\t.st34{fill:#F59689;}\r\n\t.st35{fill:#DDC9AC;}\r\n\t.st36{fill:#D24E5C;}\r\n\t.st37{fill:#6A5C52;}\r\n\t.st38{fill:#6CA6BE;}\r\n\t.st39{fill:#B8C136;}\r\n\t.st40{fill-rule:evenodd;clip-rule:evenodd;fill:#FAE6CA;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 4.829,
    x2: 256,
    y2: 4.829
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 16.56,
    x2: 256,
    y2: 16.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 28.29,
    x2: 256,
    y2: 28.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 40.021,
    x2: 256,
    y2: 40.021
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 51.751,
    x2: 256,
    y2: 51.751
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 63.482,
    x2: 256,
    y2: 63.482
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 75.213,
    x2: 256,
    y2: 75.213
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 86.943,
    x2: 256,
    y2: 86.943
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 98.674,
    x2: 256,
    y2: 98.674
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 110.404,
    x2: 256,
    y2: 110.404
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 122.135,
    x2: 256,
    y2: 122.135
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 133.865,
    x2: 256,
    y2: 133.865
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 145.596,
    x2: 256,
    y2: 145.596
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 157.326,
    x2: 256,
    y2: 157.326
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 169.057,
    x2: 256,
    y2: 169.057
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 180.788,
    x2: 256,
    y2: 180.788
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 192.518,
    x2: 256,
    y2: 192.518
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 204.249,
    x2: 256,
    y2: 204.249
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 215.979,
    x2: 256,
    y2: 215.979
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 227.71,
    x2: 256,
    y2: 227.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 239.44,
    x2: 256,
    y2: 239.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 251.171,
    x2: 256,
    y2: 251.171
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 251.171,
    y1: 0,
    x2: 251.171,
    y2: 256
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 239.44,
    y1: 0,
    x2: 239.44,
    y2: 256
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 227.71,
    y1: 0,
    x2: 227.71,
    y2: 256
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 215.979,
    y1: 0,
    x2: 215.979,
    y2: 256
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 204.249,
    y1: 0,
    x2: 204.249,
    y2: 256
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 192.518,
    y1: 0,
    x2: 192.518,
    y2: 256
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 180.788,
    y1: 0,
    x2: 180.788,
    y2: 256
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 169.057,
    y1: 0,
    x2: 169.057,
    y2: 256
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 157.326,
    y1: 0,
    x2: 157.326,
    y2: 256
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 145.596,
    y1: 0,
    x2: 145.596,
    y2: 256
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 133.865,
    y1: 0,
    x2: 133.865,
    y2: 256
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 122.135,
    y1: 0,
    x2: 122.135,
    y2: 256
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 110.404,
    y1: 0,
    x2: 110.404,
    y2: 256
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 98.674,
    y1: 0,
    x2: 98.674,
    y2: 256
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 86.943,
    y1: 0,
    x2: 86.943,
    y2: 256
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 75.212,
    y1: 0,
    x2: 75.212,
    y2: 256
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 63.482,
    y1: 0,
    x2: 63.482,
    y2: 256
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 51.751,
    y1: 0,
    x2: 51.751,
    y2: 256
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 40.021,
    y1: 0,
    x2: 40.021,
    y2: 256
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 28.29,
    y1: 0,
    x2: 28.29,
    y2: 256
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 16.56,
    y1: 0,
    x2: 16.56,
    y2: 256
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 4.829,
    y1: 0,
    x2: 4.829,
    y2: 256
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M16.757,126.303v113.145c35.613-14.751,75.628-14.751,111.241,0V90.383 c-35.613-14.752-75.628-14.752-111.241,0v22.664V126.303z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M127.998,240.949c-0.194,0-0.39-0.038-0.574-0.114c-35.497-14.704-74.596-14.703-110.093,0 c-0.461,0.192-0.99,0.14-1.407-0.139c-0.417-0.278-0.667-0.746-0.667-1.247V126.303c0-0.829,0.672-1.5,1.5-1.5 c0.828,0,1.5,0.671,1.5,1.5v110.918c34.99-13.889,73.253-13.889,108.241,0V91.389c-34.942-14.199-73.299-14.198-108.241,0v21.658 c0,0.829-0.672,1.5-1.5,1.5c-0.828,0-1.5-0.671-1.5-1.5V90.383c0-0.607,0.365-1.154,0.926-1.386 c36.238-15.011,76.151-15.011,112.39,0c0.561,0.232,0.926,0.779,0.926,1.386v149.065c0,0.501-0.25,0.969-0.667,1.247 C128.581,240.863,128.29,240.949,127.998,240.949z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M47.911,26.228c0,0,3.408,12.659,13.222,13.246c0,0-13.1,4.525-13.321,14.202 c0,0-2.578-13.572-12.925-14.059C34.887,39.618,46.937,37.792,47.911,26.228z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M47.81,55.176c-0.713,0-1.335-0.506-1.473-1.217c-0.023-0.124-2.494-12.418-11.521-12.843 c-0.771-0.037-1.388-0.651-1.428-1.421c-0.04-0.771,0.511-1.445,1.273-1.561c0.441-0.069,10.895-1.817,11.754-12.032 c0.061-0.725,0.635-1.301,1.359-1.367c0.736-0.062,1.394,0.399,1.584,1.102c0.031,0.116,3.259,11.626,11.863,12.14 c0.714,0.043,1.297,0.584,1.396,1.292c0.098,0.708-0.318,1.388-0.994,1.623c-0.121,0.042-12.118,4.31-12.313,12.819 c-0.018,0.767-0.611,1.396-1.375,1.459C47.894,55.175,47.852,55.176,47.81,55.176z M40.069,39.447 c3.878,1.969,6.231,5.746,7.587,8.876c2.026-4.021,5.942-6.787,8.949-8.427c-4.134-1.842-6.783-5.651-8.334-8.722 C46.478,35.534,43,38.042,40.069,39.447z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M26.212,43.209c0,0,2.411,8.954,9.352,9.369c0,0-9.266,3.201-9.422,10.045c0,0-1.824-9.6-9.142-9.944 C17,52.679,25.524,51.388,26.212,43.209z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M26.142,64.123c-0.714,0-1.337-0.507-1.473-1.22c-0.016-0.082-1.704-8.442-7.739-8.726 c-0.771-0.037-1.388-0.651-1.428-1.421c-0.04-0.771,0.511-1.445,1.273-1.561c0.296-0.047,7.363-1.243,7.942-8.113 c0.062-0.726,0.636-1.303,1.361-1.368c0.717-0.057,1.392,0.399,1.582,1.102l0,0c0.021,0.079,2.227,7.919,7.993,8.264 c0.714,0.043,1.299,0.584,1.396,1.293c0.097,0.709-0.32,1.388-0.996,1.622c-0.081,0.028-8.282,2.953-8.412,8.662 c-0.018,0.767-0.611,1.397-1.376,1.461C26.225,64.122,26.183,64.123,26.142,64.123z M21.622,52.596 c2.107,1.333,3.523,3.394,4.447,5.28c1.376-2.232,3.515-3.872,5.365-4.973c-2.287-1.269-3.885-3.35-4.941-5.224 C25.319,49.966,23.477,51.555,21.622,52.596z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M26.212,16.551c0,0,2.411,8.954,9.352,9.37c0,0-9.266,3.201-9.422,10.045c0,0-1.824-9.6-9.142-9.944 C17,26.022,25.524,24.731,26.212,16.551z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M26.142,37.466c-0.714,0-1.337-0.507-1.473-1.22c-0.016-0.082-1.704-8.442-7.739-8.726 c-0.771-0.037-1.388-0.651-1.428-1.421c-0.04-0.771,0.511-1.445,1.273-1.56c0.296-0.047,7.363-1.243,7.942-8.114 c0.062-0.726,0.636-1.303,1.361-1.368c0.717-0.063,1.392,0.399,1.582,1.102l0,0c0.021,0.079,2.227,7.92,7.993,8.265 c0.714,0.043,1.299,0.584,1.396,1.294c0.097,0.709-0.32,1.388-0.996,1.622c-0.081,0.028-8.282,2.952-8.412,8.662 c-0.018,0.767-0.611,1.397-1.376,1.461C26.225,37.465,26.183,37.466,26.142,37.466z M21.622,25.938 c2.107,1.333,3.523,3.395,4.447,5.28c1.376-2.233,3.516-3.872,5.365-4.972c-2.287-1.269-3.885-3.35-4.941-5.224 C25.319,23.309,23.477,24.897,21.622,25.938z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M239.243,90.383c-35.613-14.752-75.628-14.752-111.241,0c0,49.689,0,99.377,0,149.065 c35.613-14.751,75.628-14.751,111.241,0C239.243,189.76,239.243,140.072,239.243,90.383z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M239.243,240.949c-0.194,0-0.39-0.038-0.574-0.114c-35.497-14.704-74.598-14.703-110.093,0 c-0.461,0.192-0.99,0.14-1.407-0.139c-0.417-0.278-0.667-0.746-0.667-1.247V90.383c0-0.607,0.365-1.154,0.926-1.386 c36.237-15.009,76.15-15.01,112.39,0c0.561,0.232,0.926,0.779,0.926,1.386v149.065c0,0.501-0.25,0.969-0.667,1.247 C239.826,240.863,239.535,240.949,239.243,240.949z M183.623,226.805c18.312,0,36.625,3.472,54.12,10.416V91.389 c-34.944-14.199-73.299-14.198-108.241,0v145.832C146.997,230.277,165.31,226.805,183.623,226.805z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M115.178,212.874c-0.145,0-0.295-0.021-0.442-0.067c-27.717-8.549-57.012-8.548-84.715,0 c-0.799,0.246-1.632-0.201-1.876-0.991c-0.244-0.792,0.2-1.631,0.991-1.876c28.283-8.727,58.187-8.727,86.484,0 c0.791,0.244,1.235,1.084,0.991,1.875C116.412,212.46,115.819,212.874,115.178,212.874z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M141.409,212.68c-0.643,0-1.237-0.417-1.435-1.064c-0.24-0.793,0.207-1.63,0.999-1.871 c27.817-8.452,57.24-8.471,85.089-0.056c0.793,0.24,1.242,1.077,1.002,1.87c-0.238,0.794-1.079,1.239-1.869,1.002 c-27.279-8.243-56.101-8.224-83.349,0.054C141.701,212.659,141.554,212.68,141.409,212.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M29.577,192.164c-0.641,0-1.233-0.414-1.433-1.058c-0.244-0.792,0.2-1.631,0.991-1.876 c28.283-8.728,58.187-8.727,86.484,0c0.791,0.244,1.235,1.084,0.991,1.875c-0.244,0.792-1.081,1.236-1.876,0.992 c-27.717-8.549-57.012-8.548-84.715,0C29.873,192.142,29.724,192.164,29.577,192.164z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M141.409,191.971c-0.643,0-1.237-0.417-1.435-1.064c-0.24-0.792,0.207-1.63,0.999-1.871 c27.818-8.453,57.241-8.471,85.089-0.056c0.793,0.24,1.242,1.077,1.002,1.87c-0.238,0.794-1.079,1.24-1.869,1.002 c-27.279-8.244-56.101-8.225-83.349,0.054C141.701,191.95,141.554,191.971,141.409,191.971z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M115.178,171.454c-0.145,0-0.295-0.021-0.442-0.067c-27.717-8.549-57.012-8.548-84.715-0.001 c-0.799,0.244-1.632-0.201-1.876-0.991c-0.244-0.791,0.2-1.631,0.991-1.876c28.283-8.727,58.187-8.727,86.484,0 c0.791,0.244,1.235,1.084,0.991,1.875C116.412,171.04,115.819,171.454,115.178,171.454z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M141.409,171.261c-0.643,0-1.237-0.417-1.435-1.064c-0.24-0.793,0.207-1.63,0.999-1.871 c27.818-8.452,57.241-8.47,85.089-0.056c0.793,0.24,1.242,1.077,1.002,1.87c-0.238,0.793-1.079,1.241-1.869,1.002 c-27.279-8.243-56.101-8.224-83.349,0.054C141.701,171.24,141.554,171.261,141.409,171.261z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M115.178,150.745c-0.145,0-0.295-0.021-0.442-0.067c-27.717-8.549-57.012-8.548-84.715-0.001 c-0.799,0.246-1.632-0.201-1.876-0.991c-0.244-0.791,0.2-1.631,0.991-1.875c28.283-8.728,58.187-8.727,86.484-0.001 c0.791,0.244,1.235,1.084,0.991,1.876C116.412,150.331,115.819,150.745,115.178,150.745z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M141.409,150.551c-0.643,0-1.237-0.417-1.435-1.064c-0.24-0.792,0.207-1.63,0.999-1.871 c27.818-8.453,57.241-8.471,85.089-0.056c0.793,0.24,1.242,1.077,1.002,1.87c-0.238,0.794-1.079,1.24-1.869,1.002 c-27.279-8.244-56.101-8.225-83.349,0.054C141.701,150.53,141.554,150.551,141.409,150.551z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M29.577,130.035c-0.641,0-1.233-0.414-1.433-1.058c-0.244-0.791,0.2-1.631,0.991-1.875 c28.283-8.728,58.187-8.727,86.484,0c0.791,0.244,1.235,1.084,0.991,1.876c-0.244,0.792-1.081,1.236-1.876,0.992 c-27.717-8.549-57.012-8.548-84.715-0.001C29.873,130.013,29.724,130.035,29.577,130.035z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M141.409,129.841c-0.643,0-1.237-0.417-1.435-1.064c-0.24-0.793,0.207-1.63,0.999-1.871 c27.818-8.452,57.241-8.47,85.089-0.056c0.793,0.24,1.242,1.077,1.002,1.87c-0.238,0.794-1.079,1.241-1.869,1.002 c-27.279-8.243-56.101-8.224-83.349,0.054C141.701,129.82,141.554,129.841,141.409,129.841z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M115.178,109.325c-0.145,0-0.295-0.021-0.442-0.067c-27.717-8.549-57.012-8.548-84.715-0.001 c-0.799,0.244-1.632-0.201-1.876-0.991c-0.244-0.791,0.2-1.631,0.991-1.875c28.283-8.728,58.187-8.727,86.484-0.001 c0.791,0.244,1.235,1.084,0.991,1.876C116.412,108.911,115.819,109.325,115.178,109.325z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M141.409,109.132c-0.643,0-1.237-0.417-1.435-1.064c-0.24-0.792,0.207-1.63,0.999-1.871 c27.817-8.452,57.24-8.471,85.089-0.056c0.793,0.24,1.242,1.077,1.002,1.87c-0.238,0.794-1.079,1.239-1.869,1.002 c-27.279-8.243-56.101-8.224-83.349,0.054C141.701,109.111,141.554,109.132,141.409,109.132z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M100.41,149.048l18.691-18.69c-2.927-2.051-5.713-4.384-8.323-6.993c-2.609-2.609-4.943-5.395-6.993-8.323 l-62.204,62.204c-4.229,4.229-4.229,11.087,0,15.316c4.229,4.23,11.087,4.229,15.316,0l34.141-34.141L100.41,149.048z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M49.238,197.228c-3.157,0-6.315-1.202-8.718-3.605c-2.329-2.329-3.611-5.425-3.611-8.719 c0-3.293,1.282-6.39,3.611-8.718l62.204-62.204c0.312-0.313,0.745-0.471,1.191-0.434c0.441,0.038,0.844,0.271,1.098,0.634 c2.012,2.873,4.308,5.605,6.825,8.123c2.516,2.515,5.248,4.811,8.122,6.826c0.363,0.254,0.596,0.656,0.634,1.098 c0.039,0.441-0.12,0.878-0.434,1.191l-18.69,18.69c-0.586,0.586-1.535,0.586-2.121,0c-0.586-0.585-0.586-1.536,0-2.121 l17.445-17.445c-2.489-1.852-4.864-3.904-7.077-6.118c-2.215-2.215-4.268-4.589-6.117-7.077l-60.959,60.959 c-1.762,1.762-2.732,4.105-2.732,6.597c0,2.492,0.971,4.836,2.732,6.598c3.638,3.638,9.557,3.637,13.194,0l34.141-34.141 c0.586-0.586,1.535-0.586,2.121,0c0.586,0.586,0.586,1.536,0,2.121l-34.141,34.141C55.554,196.026,52.395,197.227,49.238,197.228z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M130.627,136.75l-4.921,4.921c-3.5,3.5-9.185,3.5-12.686,0l-20.549-20.548c-3.5-3.5-3.5-9.185,0-12.686 l4.922-4.922c3.04,7.213,7.509,13.972,13.385,19.849C116.654,129.24,123.414,133.71,130.627,136.75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M119.362,145.797c-2.798,0-5.428-1.088-7.403-3.065L91.41,122.184c-4.082-4.083-4.082-10.725,0-14.807 l4.922-4.921c0.353-0.353,0.86-0.504,1.349-0.412c0.49,0.096,0.9,0.429,1.094,0.889c3.051,7.235,7.446,13.752,13.064,19.371 c5.618,5.619,12.136,10.014,19.371,13.064c0.46,0.194,0.793,0.604,0.889,1.094c0.097,0.49-0.058,0.996-0.411,1.349l-4.922,4.921 C124.79,144.708,122.16,145.797,119.362,145.797z M96.906,106.124l-3.375,3.374c-2.912,2.913-2.912,7.651,0,10.564l20.549,20.548 c1.409,1.41,3.285,2.186,5.282,2.186s3.873-0.776,5.282-2.186l3.374-3.374c-6.787-3.143-12.936-7.446-18.301-12.812 C104.352,119.06,100.05,112.912,96.906,106.124z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5191 -0.8547 0.8547 0.5191 6.9207 170.5404)",
    className: "st8",
    cx: 155.023,
    cy: 79.12,
    rx: 62.568,
    ry: 62.568
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M155.023,143.158c-16.406,0-32.813-6.245-45.303-18.735c-24.98-24.98-24.98-65.626,0-90.606 c24.981-24.979,65.626-24.981,90.607,0c24.98,24.98,24.98,65.627,0,90.606l0,0C187.836,136.913,171.43,143.158,155.023,143.158z  M155.023,18.08c-15.641,0-31.275,5.951-43.183,17.857c-23.811,23.811-23.811,62.554,0,86.364 c23.813,23.811,62.554,23.809,86.364,0c23.811-23.811,23.811-62.554,0-86.364C186.301,24.034,170.659,18.08,155.023,18.08z  M199.266,123.362h0.01H199.266z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8507 -0.5257 0.5257 0.8507 -18.4431 93.3169)",
    className: "st9",
    cx: 155.023,
    cy: 79.12,
    rx: 46.593,
    ry: 46.593
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M155.023,127.19c-12.316,0-24.631-4.688-34.007-14.063c-18.751-18.752-18.751-49.263,0-68.014 c18.752-18.751,49.263-18.752,68.015,0l0,0c18.751,18.751,18.751,49.262,0,68.014C179.654,122.502,167.339,127.19,155.023,127.19z  M155.023,34.047c-11.548,0-23.096,4.396-31.887,13.186c-17.581,17.582-17.581,46.19,0,63.772 c17.582,17.582,46.19,17.581,63.772,0c17.581-17.582,17.581-46.189,0-63.772C178.118,38.443,166.57,34.047,155.023,34.047z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M218.78,85.158c-0.14,1.5-0.34,2.99-0.58,4.47c0.015,0.006,0.03,0.011,0.046,0.017 c2.714,1.001,4.495,3.616,4.495,6.509v9.034c1.11,0.3,2.22,0.62,3.32,0.95c0.8,0.24,1.24,1.08,1,1.87c-0.23,0.8-1.07,1.24-1.86,1 c-0.82-0.25-1.64-0.49-2.46-0.71v17.59c1.07,0.299,2.14,0.607,3.202,0.925c0.723,0.216,1.256,0.904,1.169,1.654 c-0.109,0.943-1.04,1.516-1.911,1.251c-0.82-0.25-1.64-0.49-2.46-0.71v17.59c1.07,0.299,2.14,0.607,3.202,0.925 c0.723,0.216,1.256,0.904,1.169,1.654c-0.109,0.942-1.04,1.515-1.911,1.251c-0.82-0.25-1.64-0.49-2.46-0.72v17.6 c1.07,0.299,2.14,0.607,3.202,0.924c0.723,0.216,1.256,0.904,1.169,1.654c-0.109,0.943-1.04,1.516-1.911,1.251 c-0.82-0.25-1.64-0.49-2.46-0.72v17.6c1.07,0.299,2.14,0.607,3.202,0.924c0.723,0.216,1.256,0.904,1.169,1.654 c-0.109,0.943-1.04,1.516-1.911,1.251c-0.82-0.25-1.64-0.49-2.46-0.72v17.6c1.07,0.299,2.14,0.607,3.201,0.924 c0.723,0.216,1.256,0.904,1.169,1.654c-0.109,0.943-1.04,1.516-1.911,1.251c-0.82-0.25-1.64-0.49-2.46-0.72v20.33 c5.05,1.41,10.06,3.09,15,5.05V91.388C231.52,88.858,225.18,86.788,218.78,85.158z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudit);
export default __webpack_public_path__ + "static/media/audit.97592d25e97bf8c3fe6dfe86d1e7c535.svg";
export { ForwardRef as ReactComponent };